module.exports = __webpack_public_path__ + "01e206a17da337799b020f249d3d8f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/soudure_metal_acl.jpg
// module id = MvkX
// module chunks = 0